(function () {
  'use strict';

  /* Generic config-driven builder for pebble hanging hearts.
     Config JSON comes from snippets/dm-heart-builder.liquid; property keys in
     the config are verbatim from real orders (SCHEMA_HARVEST 4 Jul 2026) and
     must be emitted exactly as-is, trailing spaces included. */

  var CART_TIMEOUT_MS = 12000;
  var submitting = false;

  function qs(root, sel) { return (root || document).querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function clean(v) { return (v || '').replace(/\s+/g, ' ').trim(); }
  function money(pence) { return '\xA3' + (pence / 100).toFixed(2); }
  function escapeHtml(v) {
    return String(v || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function noun(config, cap) {
    var n = (config && config.itemNoun) || 'heart';
    return cap ? n.charAt(0).toUpperCase() + n.slice(1) : n;
  }

  // Optional per-product price-step note under the pebble counter (config.pebbles.stepNotes).
  // Products without stepNotes render nothing, exactly as before.
  function stepNoteHtml(p, attr) {
    if (!p || !p.stepNotes || !p.stepNotes.length) return '';
    return '<p class="dm-pebble-step-note" ' + attr + ' hidden style="margin:8px 0 0;font-size:13px;line-height:1.4;color:#6b1f2a;"></p>';
  }

  function setStepNote(el, p, count) {
    if (!el || !p || !p.stepNotes) return;
    var text = '';
    p.stepNotes.forEach(function (n) { if (count >= n.from) text = n.text; });
    el.textContent = text;
    el.hidden = !text;
  }

  function ensureLayoutStyles() {
    if (qs(document, '[data-heart-layout-styles]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-heart-layout-styles', '');
    style.textContent = [
      '@media (max-width: 767px) { .dm-heart-options--centered { margin-left: calc(50% - 50vw) !important; margin-right: calc(50% - 50vw) !important; border-left: 0 !important; border-right: 0 !important; border-radius: 0 !important; } }',
      '.dm-heart-options--centered .daisy-street-options__header, .dm-heart-options--centered .daisy-street-options__group-title { text-align: center; }',
      '.dm-heart-options--centered .daisy-street-options__size-grid { display: grid !important; grid-template-columns: repeat(2, minmax(0, 1fr)) !important; gap: 10px !important; width: 100%; }',
      '.dm-heart-options--centered .daisy-street-options__size-grid .daisy-street-options__choice { justify-content: center !important; text-align: center; margin: 0 !important; width: auto !important; }',
      '.dm-heart-options--centered .daisy-street-options__size-grid .daisy-street-options__choice-main { justify-content: center !important; flex: 0 1 auto !important; }',
      '.dm-cyg__card--cards .dm-cyg__top { justify-content: center; text-align: center; }',
      '.dm-boxcards { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin-top: 10px; }',
      '.dm-boxcards--extras { display: flex; flex-wrap: wrap; justify-content: center; gap: 10px; margin-top: 10px; padding: 0 16px; }',
      '.dm-boxcards--open { display: flex; flex-wrap: wrap; justify-content: center; }',
      '.dm-boxrow { display: flex !important; align-items: center; gap: 12px; width: 100%; margin: 8px 0 0 !important; padding: 10px 12px !important; border: 1px solid #e4ddd4; border-radius: 12px; background: #fff; color: #232323; font: inherit; text-align: left; cursor: pointer; -webkit-appearance: none; appearance: none; }',
      '.dm-boxrow[hidden] { display: none !important; }',
      '.dm-boxrow.is-active { background: #f3f5ec; border-color: #b0af9b; box-shadow: inset 0 0 0 1px #b0af9b; }',
      '.dm-boxrow__img { width: 64px; height: 64px; border-radius: 8px; object-fit: cover; flex-shrink: 0; }',
      '.dm-boxrow__text { display: grid; gap: 2px; flex: 1; min-width: 0; }',
      '.dm-boxrow__title { font-weight: 600; font-size: 15px; line-height: 1.25; }',
      '.dm-boxrow__price { font-size: 14px; color: #555; }',
      '.dm-boxrow__cta { flex-shrink: 0; padding: 8px 14px; border-radius: 999px; background: #1f1f1f; color: #fff; font-size: 13px; font-weight: 600; white-space: nowrap; }',
      '.dm-boxrow.is-active .dm-boxrow__cta { background: #b0af9b; color: #1f1f1f; }',
      '.dm-boxrow__on { display: none; } .dm-boxrow.is-active .dm-boxrow__on { display: inline; } .dm-boxrow.is-active .dm-boxrow__off { display: none; }',
      '.dm-boxcards--open .dm-boxcard[data-heart-boxmode="none"] { flex: 1 1 100%; }',
      '.dm-boxcards--open .dm-boxcard:not([data-heart-boxmode="none"]) { flex: 0 1 calc(50% - 5px); max-width: 240px; }',
      '.dm-boxcards--extras .dm-extra-card { flex: 0 1 calc(50% - 5px); }',
      '.dm-boxcard, .dm-extra-card { position: relative; display: flex !important; flex-direction: column; align-items: center; justify-content: flex-start; gap: 6px; min-height: 48px; margin: 0 !important; padding: 12px 10px !important; border: 1px solid #e4ddd4; border-radius: 12px; background: #fff; color: #232323; font: inherit; line-height: 1.3; cursor: pointer; text-align: center; -webkit-appearance: none; appearance: none; transition: background .15s ease, color .15s ease, border-color .15s ease; }',
      '.dm-boxcard[data-heart-boxmode="none"] { grid-column: 1 / -1; flex-direction: row; min-height: 40px; padding: 9px 10px !important; color: #6a6a6a; background: #fafaf8; font-size: 13px; }',
      '.dm-boxcard[data-heart-boxmode="none"].is-active { background: #f3f5ec; border-color: #b0af9b; box-shadow: inset 0 0 0 1px #b0af9b; color: #232323; }',
      '.dm-boxcard[hidden] { display: none !important; }',
      '.dm-boxcard__badge { display: inline-block; padding: 3px 9px; border-radius: 999px; background: #1a1a1a; color: #fff; font-size: 10px; font-weight: 800; letter-spacing: .08em; text-transform: uppercase; }',
      '.dm-boxcard[data-heart-boxmode="double"] .dm-boxcard__badge { background: #6b1f2a; }',
      '.dm-boxcard__img, .dm-extra-card__img { width: 100%; max-width: 140px; aspect-ratio: 1 / 1; object-fit: cover; border-radius: 10px; margin: 2px auto 0; }',
      '.dm-extra-card__body { display: flex; flex-direction: column; align-items: center; gap: 6px; width: 100%; }',
      '.dm-boxcard__title, .dm-extra-card .daisy-street-options__choice-title { font-weight: 700; font-size: 14px; }',
      '.dm-boxcard__price, .dm-extra-card .daisy-street-options__price { font-weight: 800; font-size: 15px; margin: 0; }',
      '.dm-extra-card .daisy-street-options__choice-note { display: none; }',
      '.dm-boxcard__cta, .dm-extra-card__cta { display: inline-block; margin-top: 4px; padding: 7px 14px; border-radius: 999px; background: #1a1a1a; color: #fbf7ef; font-size: 12px; font-weight: 800; }',
      '.dm-boxcard__cta-on, .dm-extra-card__cta-on { display: none; }',
      '.dm-boxcard.is-active:not([data-heart-boxmode="none"]), .dm-extra-card.is-selected { background: #1a1a1a !important; border-color: #1a1a1a !important; color: #fbf7ef !important; box-shadow: none !important; }',
      '.dm-boxcard.is-active:not([data-heart-boxmode="none"]) .dm-boxcard__badge, .dm-boxcard.is-active:not([data-heart-boxmode="none"]) .dm-boxcard__cta, .dm-extra-card.is-selected .dm-extra-card__cta, .dm-extra-card.is-selected .dm-boxcard__badge { background: #fbf7ef !important; color: #1a1a1a !important; }',
      '.dm-boxcard.is-active .dm-boxcard__cta-on, .dm-extra-card.is-selected .dm-extra-card__cta-on { display: inline; }',
      '.dm-boxcard.is-active .dm-boxcard__cta-off, .dm-extra-card.is-selected .dm-extra-card__cta-off { display: none; }',
      '.dm-extra-card.is-selected .daisy-street-options__choice-note, .dm-extra-card.is-selected .daisy-street-options__price, .dm-extra-card.is-selected .daisy-street-options__choice-title { color: #fbf7ef !important; }',
      '.dm-extra-card input[type="checkbox"] { position: absolute; opacity: 0; width: 1px; height: 1px; margin: 0; pointer-events: none; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function readConfig(root) {
    var node = qs(root, '[data-daisy-heart-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function fieldInput(field, idx, offer) {
    var attr = 'data-heart-field="' + (offer ? 'offer-' : 'main-') + idx + '"';
    if (field.type === 'select') {
      return [
        '<label class="daisy-street-options__field">',
        '<span class="daisy-street-options__label">' + escapeHtml(field.label) + (field.required ? ' <span style="color:#c00;font-weight:500">*</span>' : '') + '</span>',
        '<select ' + attr + '>',
        '<option value="">Please select</option>',
        (field.values || []).map(function (v) { return '<option value="' + escapeHtml(v) + '"' + (field.default === v ? ' selected' : '') + '>' + escapeHtml(v) + '</option>'; }).join(''),
        '</select>',
        '</label>'
      ].join('');
    }
    return [
      '<label class="daisy-street-options__field">',
      '<span class="daisy-street-options__label">' + escapeHtml(field.label) + (field.required ? ' <span style="color:#c00;font-weight:500">*</span>' : '') + '</span>',
      '<input type="text" ' + attr + ' maxlength="80" autocomplete="off" placeholder="' + escapeHtml(field.placeholder || '') + '">',
      (field.helper ? '<small class="dm-heart-helper" style="display:block;margin:4px 0 0;font-size:12px;line-height:1.4;color:#5a5a5a;font-weight:400;">' + escapeHtml(field.helper) + '</small>' : ''),
      '</label>'
    ].join('');
  }

  function sizeChoice(opt, idx) {
    if (opt.hex) {
      return [
        '<label class="daisy-street-options__choice' + (idx === 0 ? ' is-selected' : '') + '" data-pop-colour="' + escapeHtml(opt.hex) + '" style="justify-content:flex-start;">',
        '<input type="radio" name="daisy-heart-size" value="' + idx + '"' + (idx === 0 ? ' checked' : '') + '>',
        '<span class="daisy-street-options__choice-main" style="display:flex;align-items:center;">',
        '<span style="display:inline-block;width:16px;height:16px;border-radius:50%;background:' + escapeHtml(opt.hex) + ';border:1px solid rgba(0,0,0,.18);margin-right:8px;flex-shrink:0;"></span>',
        '<span class="daisy-street-options__choice-title">' + escapeHtml(opt.label) + '</span>',
        '</span>',
        '</label>'
      ].join('');
    }
    return [
      '<label class="daisy-street-options__choice daisy-street-options__choice--size' + (idx === 0 ? ' is-selected' : '') + '">',
      '<input type="radio" name="daisy-heart-size" value="' + idx + '"' + (idx === 0 ? ' checked' : '') + '>',
      '<span class="daisy-street-options__choice-main">',
      '<span class="daisy-street-options__choice-title">' + escapeHtml(opt.label) + '</span>',
      '<span class="daisy-street-options__choice-note">' + escapeHtml(opt.note || '') + '</span>',
      '</span>',
      '<span class="daisy-street-options__price">' + (opt.extraPence ? '+' + money(opt.extraPence) : 'Included') + '</span>',
      '</label>'
    ].join('');
  }

  function pebbleBlock(config) {
    if (!config.pebbles) return '';
    var p = config.pebbles;
    var rows = [];
    for (var i = 0; i < p.max; i++) {
      rows.push(
        '<label class="daisy-street-options__field" data-heart-pebble-row="' + i + '"' + (i >= p.defaultCount ? ' hidden' : '') + '>',
        '<span class="daisy-street-options__label">Pebble ' + (i + 1) + '</span>',
        '<select data-heart-pebble="' + i + '"' + (i >= p.defaultCount ? ' disabled' : '') + '>',
        '<option value="">Please select</option>',
        p.types.map(function (t) { return '<option value="' + escapeHtml(t) + '">' + escapeHtml(t) + '</option>'; }).join(''),
        '</select>',
        '</label>'
      );
    }
    return [
      '<section class="daisy-street-options__group">',
      '<p class="daisy-street-options__group-title">Pebble characters</p>',
      '<div class="dm-teacher-pebble__count-row">',
      '<div class="dm-teacher-pebble__count-wrap">',
      '<button type="button" class="dm-teacher-pebble__count-btn" data-heart-count-minus aria-label="Remove a pebble">−</button>',
      '<span class="dm-teacher-pebble__count-val" data-heart-count>' + p.defaultCount + '</span>',
      '<button type="button" class="dm-teacher-pebble__count-btn" data-heart-count-plus aria-label="Add a pebble">+</button>',
      '</div>',
      '<span class="dm-teacher-pebble__count-hint">select number of pebbles</span>',
      '</div>',
      stepNoteHtml(p, 'data-heart-count-note'),
      '<div class="daisy-street-options__grid daisy-street-options__grid--text">',
      rows.join(''),
      '</div>',
      '</section>'
    ].join('');
  }

  function giftBoxDesigns(config) {
    return config.giftBox.designs || [config.giftBox];
  }

  function boxFor(design, sizeValue) {
    return /large/i.test(sizeValue || '') ? design.large : design.small;
  }

  function offerSizeValue(config, s) {
    if (s.offerSize) return s.offerSize.value;
    return (config.offer && config.offer.offerSizeValue) || '';
  }

  function offerSizeChoice(opt, idx) {
    if (opt.hex) {
      return [
        '<label class="daisy-street-options__choice' + (idx === 0 ? ' is-selected' : '') + '" data-pop-colour="' + escapeHtml(opt.hex) + '" style="justify-content:flex-start;">',
        '<input type="radio" name="daisy-heart-offer-size" value="' + idx + '"' + (idx === 0 ? ' checked' : '') + '>',
        '<span class="daisy-street-options__choice-main" style="display:flex;align-items:center;">',
        '<span style="display:inline-block;width:16px;height:16px;border-radius:50%;background:' + escapeHtml(opt.hex) + ';border:1px solid rgba(0,0,0,.18);margin-right:8px;flex-shrink:0;"></span>',
        '<span class="daisy-street-options__choice-title">' + escapeHtml(opt.label) + '</span>',
        '</span>',
        '</label>'
      ].join('');
    }
    return [
      '<label class="daisy-street-options__choice daisy-street-options__choice--size' + (idx === 0 ? ' is-selected' : '') + '">',
      '<input type="radio" name="daisy-heart-offer-size" value="' + idx + '"' + (idx === 0 ? ' checked' : '') + '>',
      '<span class="daisy-street-options__choice-main">',
      '<span class="daisy-street-options__choice-title">' + escapeHtml(opt.label) + '</span>',
      '<span class="daisy-street-options__choice-note">' + escapeHtml(opt.note || '') + '</span>',
      '</span>',
      '<span class="daisy-street-options__price">' + (opt.extraPence ? '+' + money(opt.extraPence) : 'Included') + '</span>',
      '</label>'
    ].join('');
  }

  function giftBoxPickerHtml(config, scope, label) {
    var designs = giftBoxDesigns(config);
    return [
      '<div class="dm-wedding-heart__box-picker" data-heart-box-picker="' + scope + '" hidden>',
      '<p>' + escapeHtml(label) + '</p>',
      '<div class="dm-wedding-heart__box-grid">',
      designs.map(function (d, i) {
        return [
          '<button type="button" class="dm-wedding-heart__box-choice' + (i === 0 ? ' is-active' : '') + '" data-heart-boxdesign="' + i + '" data-heart-boxdesign-scope="' + scope + '" aria-pressed="' + (i === 0 ? 'true' : 'false') + '">',
          '<span class="dm-wedding-heart__box-thumb-wrap">',
          '<img class="dm-wedding-heart__box-thumb" src="' + d.image + '" alt="' + escapeHtml(d.title) + ' gift box" loading="lazy" width="72" height="72">',
          '<span class="dm-wedding-heart__box-zoom" data-dm-zoomable data-dm-zoom-src="' + d.zoom + '" role="button" tabindex="0" aria-label="Zoom in on ' + escapeHtml(d.title) + ' design">',
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4M11 8v6M8 11h6"/></svg>',
          '</span>',
          '</span>',
          '<span><strong>' + escapeHtml(d.title) + '</strong><small data-heart-boxfit-scope="' + scope + '" data-heart-boxfit="' + i + '">' + d.small.label + '</small></span>',
          '<b data-heart-boxprice-scope="' + scope + '" data-heart-boxprice="' + i + '">' + money(d.small.pricePence) + '</b>',
          '</button>'
        ].join('');
      }).join(''),
      '</div>',
      '</div>'
    ].join('');
  }

  function extraFor(x, s) {
    if (!(s && s.offer && x.withOffer)) return x;
    return {
      variantId: x.withOffer.variantId || x.variantId,
      pricePence: (x.withOffer.pricePence != null) ? x.withOffer.pricePence : x.pricePence,
      label: x.withOffer.label || x.label,
      note: (x.withOffer.note != null) ? x.withOffer.note : x.note
    };
  }

  function extraRow(x, i, style) {
    if (x.layout === 'card') {
      var img = x.image ? '<img class="dm-extra-card__img" src="' + escapeHtml(x.image) + '" alt="" loading="lazy">' : '';
      return '<label class="daisy-street-options__choice daisy-street-options__offer dm-extra-card"' + (x.requiresOffer ? ' data-heart-extra-needs-offer hidden' : '') + '>' +
        '<input type="checkbox" data-heart-extra="' + i + '">' +
        '<span class="dm-extra-card__body">' + (x.badge ? '<span class="dm-boxcard__badge">' + escapeHtml(x.badge) + '</span>' : '') + img +
        '<span class="daisy-street-options__choice-title" data-heart-extra-label="' + i + '">' + escapeHtml(x.label) + '</span>' +
        '<span class="daisy-street-options__choice-note" data-heart-extra-note="' + i + '">' + escapeHtml(x.note || '') + '</span>' +
        '<span class="daisy-street-options__price" data-heart-extra-price="' + i + '">+' + money(x.pricePence) + '</span>' +
        '<span class="dm-extra-card__cta"><span class="dm-extra-card__cta-off">Select</span><span class="dm-extra-card__cta-on">\u2713 Added</span></span>' +
        '</span></label>';
    }
    var thumb = x.image ? '<img src="' + escapeHtml(x.image) + '" alt="" width="56" height="56" loading="lazy" style="width:56px;height:56px;border-radius:8px;object-fit:cover;flex-shrink:0;margin-right:10px;">' : '';
    return '<label class="daisy-street-options__choice daisy-street-options__offer"' + (style ? ' style="' + style + '"' : '') + (x.requiresOffer ? ' data-heart-extra-needs-offer hidden' : '') + '>' +
      '<input type="checkbox" data-heart-extra="' + i + '">' +
      '<span class="daisy-street-options__choice-main" style="display:flex;align-items:center;">' + thumb +
      '<span style="display:grid;gap:2px;min-width:0;"><span class="daisy-street-options__choice-title" data-heart-extra-label="' + i + '">' + escapeHtml(x.label) + '</span><span class="daisy-street-options__choice-note" data-heart-extra-note="' + i + '">' + escapeHtml(x.note || '') + '</span></span></span>' +
      '<span class="daisy-street-options__price" data-heart-extra-price="' + i + '">+' + money(x.pricePence) + '</span></label>';
  }

  function giftBoxBlock(config) {
    var hasExtras = config.extras && config.extras.length;
    if (!config.giftBox && !hasExtras) return '';
    var html = [
      '<section class="daisy-street-options__group">',
      '<p class="daisy-street-options__group-title">Add-ons</p>'
    ];
    if (config.giftBox) {
      var designs = giftBoxDesigns(config);
      var gb = config.giftBox;
      if (gb.style === 'row') {
        // One compact tap-to-add row per box option (picture left, name + price, Add on the right). Tap again to remove.
        var rowImg = designs[0].image ? '<img class="dm-boxrow__img" src="' + escapeHtml(designs[0].image) + '" alt="' + escapeHtml(designs[0].title || 'Gift box') + '" loading="lazy">' : '';
        var rowCta = '<span class="dm-boxrow__cta"><span class="dm-boxrow__off">' + escapeHtml(gb.ctaOff || 'Add') + '</span><span class="dm-boxrow__on">' + escapeHtml(gb.ctaOn || '\u2713 Added') + '</span></span>';
        html.push(
          '<div class="dm-cyg__card dm-acc-off" data-heart-boxmode-group data-heart-boxmode-current="none">',
          '<button type="button" class="dm-boxrow" data-heart-boxmode="single" data-heart-boxcard data-heart-boxtoggle aria-pressed="false">' + rowImg + '<span class="dm-boxrow__text"><span class="dm-boxrow__title">' + escapeHtml(gb.labelSingle || 'Add a gift box') + '</span><span class="dm-boxrow__price">+<span data-heart-boxprice-mode="single">' + money(designs[0].small.pricePence) + '</span></span></span>' + rowCta + '</button>',
          (config.offer ? '<button type="button" class="dm-boxrow dm-addon-mode__double" data-heart-boxmode="double" data-heart-boxcard data-heart-boxtoggle aria-pressed="false" disabled hidden>' + rowImg + '<span class="dm-boxrow__text"><span class="dm-boxrow__title">' + escapeHtml(gb.labelDouble || 'Gift boxes for both') + '</span><span class="dm-boxrow__price">+<span data-heart-boxprice-mode="double">' + money(designs[0].small.pricePence * 2) + '</span></span></span>' + rowCta + '</button>' : ''),
          '</div>'
        );
      } else if (gb.style === 'cards') {
        var boxThumb = designs[0].image ? '<img class="dm-boxcard__img" src="' + escapeHtml(designs[0].image) + '" alt="" loading="lazy">' : '';
        var badge = function (t) { return t ? '<span class="dm-boxcard__badge">' + escapeHtml(t) + '</span>' : ''; };
        var cta = '<span class="dm-boxcard__cta"><span class="dm-boxcard__cta-off">' + escapeHtml(gb.ctaOff || 'Select') + '</span><span class="dm-boxcard__cta-on">' + escapeHtml(gb.ctaOn || '\u2713 Selected') + '</span></span>';
        html.push(
          // gb.open: keep the gift box cards visible (opt out of the theme's add-on accordion, like the diffusers).
          '<div class="dm-cyg__card dm-cyg__card--cards' + (gb.open ? ' dm-acc-off' : '') + '" data-heart-boxmode-group data-heart-boxmode-current="none">',
          '<div class="dm-cyg__inner">',
          '<div class="dm-cyg__top"><span class="dm-cyg__name">' + escapeHtml(gb.groupTitle || 'Gift Box') + '</span></div>',
          '<div class="dm-boxcards' + (gb.open ? ' dm-boxcards--open' : '') + '">',
          '<button type="button" class="dm-boxcard is-active" data-heart-boxmode="none" data-heart-boxcard aria-pressed="true"><span class="dm-boxcard__title">' + escapeHtml(gb.labelNone || 'No gift box') + '</span></button>',
          '<button type="button" class="dm-boxcard" data-heart-boxmode="single" data-heart-boxcard aria-pressed="false">' + badge(gb.badge) + boxThumb + '<span class="dm-boxcard__title">' + escapeHtml(gb.labelSingle || '1 gift box') + '</span><span class="dm-boxcard__price" data-heart-boxprice-mode="single">' + money(designs[0].small.pricePence) + '</span>' + cta + '</button>',
          (config.offer ? '<button type="button" class="dm-boxcard dm-addon-mode__double" data-heart-boxmode="double" data-heart-boxcard aria-pressed="false" disabled hidden>' + badge(gb.badgeDouble) + boxThumb + '<span class="dm-boxcard__title">' + escapeHtml(gb.labelDouble || '2 gift boxes') + '</span><span class="dm-boxcard__price" data-heart-boxprice-mode="double">' + money(designs[0].small.pricePence * 2) + '</span>' + cta + '</button>' : ''),
          '</div>',
          (designs.length > 1 ? giftBoxPickerHtml(config, 'main', config.offer ? 'Gift box for ' + noun(config) + ' 1' : 'Gift box design') : ''),
          (designs.length > 1 && config.offer ? giftBoxPickerHtml(config, 'offer', 'Gift box for ' + noun(config) + ' 2') : ''),
          '</div>',
          '</div>'
        );
      } else html.push(
        '<div class="dm-cyg__card" data-heart-boxmode-group data-heart-boxmode-current="none">',
        '<div class="dm-cyg__inner">',
        '<div class="dm-cyg__top"><span class="dm-cyg__name">Gift Box</span></div>',
        '<div class="dm-addon-mode">',
        '<button type="button" class="dm-addon-mode__option is-active" data-heart-boxmode="none" aria-pressed="true">No box</button>',
        '<button type="button" class="dm-addon-mode__option" data-heart-boxmode="single" aria-pressed="false">' + (config.offer ? 'Box ' + noun(config) + ' 1' : 'Add a gift box') + ' &middot; ' + money(designs[0].small.pricePence) + '</button>',
        (config.offer ? '<button type="button" class="dm-addon-mode__option dm-addon-mode__double" data-heart-boxmode="double" aria-pressed="false" disabled hidden>Box both ' + noun(config) + 's</button>' : ''),
        '</div>',
        giftBoxPickerHtml(config, 'main', config.offer ? 'Gift box for ' + noun(config) + ' 1' : 'Gift box design'),
        (config.offer ? giftBoxPickerHtml(config, 'offer', 'Gift box for ' + noun(config) + ' 2') : ''),
        '</div>',
        '</div>'
      );
    }
    if (hasExtras) {
      var cardExtras = config.extras.some(function (x) { return x.layout === 'card'; });
      if (cardExtras) html.push('<div class="dm-boxcards dm-boxcards--extras">');
      config.extras.forEach(function (x, i) {
        html.push(extraRow(x, i, cardExtras ? '' : 'margin-top:10px;'));
      });
      if (cardExtras) html.push('</div>');
    }
    html.push('</section>');
    return html.join('');
  }

  function offerPebbleBlock(config) {
    if (!config.offer || !config.offer.pebbles) return '';
    var p = config.offer.pebbles;
    var rows = [];
    for (var i = 0; i < p.max; i++) {
      rows.push(
        '<label class="daisy-street-options__field" data-heart-offer-pebble-row="' + i + '"' + (i >= p.defaultCount ? ' hidden' : '') + '>',
        '<span class="daisy-street-options__label">Pebble ' + (i + 1) + '</span>',
        '<select data-heart-offer-pebble="' + i + '"' + (i >= p.defaultCount ? ' disabled' : '') + '>',
        '<option value="">Please select</option>',
        p.types.map(function (t) { return '<option value="' + escapeHtml(t) + '">' + escapeHtml(t) + '</option>'; }).join(''),
        '</select>',
        '</label>'
      );
    }
    return [
      '<p class="daisy-street-options__group-title" style="margin:0 0 6px;font-size:12px;">Second ' + noun(config) + ' pebbles</p>',
      '<div class="dm-teacher-pebble__count-row">',
      '<div class="dm-teacher-pebble__count-wrap">',
      '<button type="button" class="dm-teacher-pebble__count-btn" data-heart-offer-count-minus aria-label="Remove a pebble">−</button>',
      '<span class="dm-teacher-pebble__count-val" data-heart-offer-count>' + p.defaultCount + '</span>',
      '<button type="button" class="dm-teacher-pebble__count-btn" data-heart-offer-count-plus aria-label="Add a pebble">+</button>',
      '</div>',
      '<span class="dm-teacher-pebble__count-hint">select number of pebbles</span>',
      '</div>',
      stepNoteHtml(p, 'data-heart-offer-count-note'),
      '<div class="daisy-street-options__grid daisy-street-options__grid--text" style="margin-bottom:10px;">',
      rows.join(''),
      '</div>'
    ].join('');
  }

  function extrasBlock(config) {
    if (!config.extras || !config.extras.length) return '';
    return [
      '<section class="daisy-street-options__group">',
      '<p class="daisy-street-options__group-title">Add-ons</p>',
      config.extras.map(function (x, i) {
        return extraRow(x, i, '');
      }).join(''),
      '</section>'
    ].join('');
  }

  function createPanel(config) {
    var panel = document.createElement('div');
    panel.className = 'daisy-street-options dm-heart-options' + (config.layout ? ' dm-heart-options--' + config.layout : '');
    ensureLayoutStyles();
    panel.setAttribute('data-heart-panel', '');
    var sizeSection = config.size ? [
      '<section class="daisy-street-options__group">',
      '<p class="daisy-street-options__group-title">' + escapeHtml(config.size.title || 'Size') + '</p>',
      '<div class="daisy-street-options__size-grid">',
      config.size.options.map(sizeChoice).join(''),
      '</div>',
      '</section>'
    ].join('') : '';
    var html = [
      '<div class="daisy-street-options__header">',
      '<p class="daisy-street-options__eyebrow">Free personalisation</p>',
      '<h2 class="daisy-street-options__title">' + escapeHtml(config.heading) + '</h2>',
      '<p class="daisy-street-options__copy">' + escapeHtml(config.copy) + '</p>',
      '</div>',
      (config.size && config.size.first) ? sizeSection : '',
      pebbleBlock(config),
      '<section class="daisy-street-options__group">',
      '<p class="daisy-street-options__group-title">Personalisation</p>',
      '<div class="daisy-street-options__grid daisy-street-options__grid--text">',
      config.fields.map(function (f, i) { return fieldInput(f, i, false); }).join(''),
      '</div>',
      (config.fieldsNote ? '<p class="dm-heart-helper" style="display:block;margin:4px 0 0;font-size:12px;line-height:1.4;color:#5a5a5a;font-weight:400;margin-top:8px;">' + escapeHtml(config.fieldsNote) + '</p>' : ''),
      '</section>',
      (config.size && config.size.first) ? '' : sizeSection
    ];
    // config.giftBoxFirst: gift box straight after personalisation, offer last (just above the total).
    if (config.giftBoxFirst) html.push(giftBoxBlock(config));
    if (config.offer) {
      html.push(
        '<section class="daisy-street-options__group">',
        '<p class="daisy-street-options__group-title">Incredible offer</p>',
        '<label class="daisy-street-options__choice daisy-street-options__offer"><input type="checkbox" name="daisy-heart-offer" value="yes"><span class="daisy-street-options__choice-main"><span class="daisy-street-options__choice-title">' + escapeHtml(config.offer.label) + '</span><span class="daisy-street-options__choice-note">' + escapeHtml(config.offer.note || '') + '</span></span><span class="daisy-street-options__price">+' + money(config.offer.pricePence) + '</span></label>',
        '<div data-heart-offer-wrap hidden style="margin-top:12px;padding:12px;border:1px solid #d7d3c5;border-radius:8px;background:#fafaf8;">',
        '<p class="daisy-street-options__group-title" style="margin:0 0 10px;font-size:13px;">Your second ' + noun(config) + '</p>',
        offerPebbleBlock(config),
        (config.offer.sizeOptions ? '<p class="daisy-street-options__group-title" style="margin:0 0 6px;font-size:12px;">' + escapeHtml(config.offer.sizeTitle || ('Second ' + noun(config) + ' size')) + '</p><div class="daisy-street-options__size-grid" style="margin-bottom:10px;">' + config.offer.sizeOptions.map(offerSizeChoice).join('') + '</div>' : ''),
        '<div class="daisy-street-options__grid daisy-street-options__grid--text">',
        config.offer.fields.map(function (f, i) { return fieldInput(f, i, true); }).join(''),
        '</div>',
        '</div>',
        '</section>'
      );
    }
    if (!config.giftBoxFirst) html.push(giftBoxBlock(config));
    html.push(
      '<div class="daisy-street-options__error" data-heart-error aria-live="polite"></div>',
      '<div class="daisy-street-options__footer"><span>Total&nbsp;</span><strong class="daisy-street-options__total" data-heart-total></strong></div>',
      '<div class="daisy-street-options__cart" data-heart-cart-slot></div>'
    );
    panel.innerHTML = html.join('');
    return panel;
  }

  function state(panel, config) {
    var sizeIdx = parseInt((qs(panel, 'input[name="daisy-heart-size"]:checked') || {}).value, 10) || 0;
    var offerEl = qs(panel, 'input[name="daisy-heart-offer"]');
    var count = config.pebbles ? (parseInt((qs(panel, '[data-heart-count]') || {}).textContent, 10) || config.pebbles.defaultCount) : 0;
    var forcedLarge = !!(config.size && config.pebbles && ((config.pebbles.maxForcesLarge && count === config.pebbles.max) || (config.pebbles.largeFrom && count >= config.pebbles.largeFrom)));
    if (forcedLarge) sizeIdx = config.size.options.length - 1;
    var offerPebbles = config.offer && config.offer.pebbles;
    var offerCount = offerPebbles ? (parseInt((qs(panel, '[data-heart-offer-count]') || {}).textContent, 10) || offerPebbles.defaultCount) : 0;
    var offerForcedLarge = !!(offerPebbles && config.offer.sizeOptions && offerPebbles.largeFrom && offerCount >= offerPebbles.largeFrom);
    return {
      sizeIdx: sizeIdx,
      size: config.size ? config.size.options[sizeIdx] : { value: (config.boxSizeFromCount && count >= config.boxSizeFromCount) ? 'Large' : '', extraPence: 0 },
      forcedLarge: forcedLarge,
      count: count,
      pebbleTypes: config.pebbles ? Array.apply(null, Array(count)).map(function (_, i) { return (qs(panel, '[data-heart-pebble="' + i + '"]') || {}).value || ''; }) : [],
      extras: (config.extras || []).map(function (x, i) { return !!(qs(panel, '[data-heart-extra="' + i + '"]') || {}).checked; }),
      offer: !!(offerEl && offerEl.checked),
      offerSize: (config.offer && config.offer.sizeOptions) ? config.offer.sizeOptions[offerForcedLarge ? config.offer.sizeOptions.length - 1 : (parseInt((qs(panel, 'input[name="daisy-heart-offer-size"]:checked') || {}).value, 10) || 0)] : null,
      offerCount: offerCount,
      offerForcedLarge: offerForcedLarge,
      offerPebbleTypes: offerPebbles ? Array.apply(null, Array(offerCount)).map(function (_, i) { return (qs(panel, '[data-heart-offer-pebble="' + i + '"]') || {}).value || ''; }) : [],
      giftBox: (function () { var g = qs(panel, '[data-heart-boxmode-group]'); return !!(g && g.getAttribute('data-heart-boxmode-current') !== 'none'); })(),
      giftBox2: (function () { var g = qs(panel, '[data-heart-boxmode-group]'); return !!(g && g.getAttribute('data-heart-boxmode-current') === 'double'); })(),
      giftBoxDesign: (function () { var b = qs(panel, '[data-heart-boxdesign-scope="main"].is-active'); return b ? parseInt(b.getAttribute('data-heart-boxdesign'), 10) || 0 : 0; })(),
      giftBoxDesign2: (function () { var b = qs(panel, '[data-heart-boxdesign-scope="offer"].is-active'); return b ? parseInt(b.getAttribute('data-heart-boxdesign'), 10) || 0 : 0; })(),
      main: config.fields.map(function (f, i) { return clean((qs(panel, '[data-heart-field="main-' + i + '"]') || {}).value); }),
      offerFields: config.offer ? config.offer.fields.map(function (f, i) { return clean((qs(panel, '[data-heart-field="offer-' + i + '"]') || {}).value); }) : []
    };
  }

  function update(panel, config) {
    var s = state(panel, config);
    var needsOffer = qsa(panel, '[data-heart-extra-needs-offer]');
    if (needsOffer.length) {
      var changed = false;
      needsOffer.forEach(function (row) {
        row.hidden = !s.offer;
        var cb = qs(row, 'input');
        if (cb && !s.offer && cb.checked) { cb.checked = false; changed = true; }
      });
      if (changed) s = state(panel, config);
    }
    var wrap = qs(panel, '[data-heart-offer-wrap]');
    if (wrap) {
      wrap.hidden = !s.offer;
      qsa(wrap, 'input').forEach(function (f) { f.disabled = !s.offer; });
    }
    if (config.pebbles) {
      qsa(panel, '[data-heart-pebble-row]').forEach(function (row) {
        var idx = parseInt(row.getAttribute('data-heart-pebble-row'), 10);
        var show = idx < s.count;
        row.hidden = !show;
        var sel = qs(row, 'select');
        if (sel) sel.disabled = !show;
      });
      var sizeInputs = qsa(panel, 'input[name="daisy-heart-size"]');
      if (s.forcedLarge) {
        sizeInputs[sizeInputs.length - 1].checked = true;
        sizeInputs.forEach(function (inp, i) { inp.disabled = i !== sizeInputs.length - 1; });
      } else {
        sizeInputs.forEach(function (inp) { inp.disabled = false; });
      }
    }
    if (config.offer && config.offer.pebbles) {
      qsa(panel, '[data-heart-offer-pebble-row]').forEach(function (row) {
        var idx = parseInt(row.getAttribute('data-heart-offer-pebble-row'), 10);
        var show = idx < s.offerCount;
        row.hidden = !show;
        var sel = qs(row, 'select');
        if (sel) sel.disabled = !show || !s.offer;
      });
      var offerSizeInputs = qsa(panel, 'input[name="daisy-heart-offer-size"]');
      if (s.offerForcedLarge) {
        if (offerSizeInputs.length) offerSizeInputs[offerSizeInputs.length - 1].checked = true;
        offerSizeInputs.forEach(function (inp, i) { inp.disabled = !s.offer || i !== offerSizeInputs.length - 1; });
      } else {
        offerSizeInputs.forEach(function (inp) { inp.disabled = !s.offer; });
      }
    }
    if (config.pebbles) setStepNote(qs(panel, '[data-heart-count-note]'), config.pebbles, s.count);
    if (config.offer && config.offer.pebbles) setStepNote(qs(panel, '[data-heart-offer-count-note]'), config.offer.pebbles, s.offerCount);
    qsa(panel, '.daisy-street-options__choice').forEach(function (node) {
      var input = qs(node, 'input');
      node.classList.toggle('is-selected', !!(input && input.checked));
    });
    var extrasTotal = (config.extras || []).reduce(function (sum, x, i) { return sum + (s.extras[i] ? extraFor(x, s).pricePence : 0); }, 0);
    (config.extras || []).forEach(function (x, i) {
      if (!x.withOffer) return;
      var ex = extraFor(x, s);
      var el1 = qs(panel, '[data-heart-extra-label="' + i + '"]'); if (el1) el1.textContent = ex.label;
      var el2 = qs(panel, '[data-heart-extra-note="' + i + '"]'); if (el2) el2.textContent = ex.note || '';
      var el3 = qs(panel, '[data-heart-extra-price="' + i + '"]'); if (el3) el3.textContent = '+' + money(ex.pricePence);
    });
    var surchargeXl = !!(config.pebbles && config.pebbles.xlFrom && s.count >= config.pebbles.xlFrom);
    var surcharge = (config.pebbles && config.pebbles.countSurcharge && !surchargeXl && s.count >= config.pebbles.countSurcharge.from) ? config.pebbles.countSurcharge.pricePence : 0;
    var giftBoxTotal = 0;
    if (config.giftBox) {
      var designs = giftBoxDesigns(config);
      var design1 = designs[s.giftBoxDesign] || designs[0];
      var design2 = designs[s.giftBoxDesign2] || designs[0];
      var group = qs(panel, '[data-heart-boxmode-group]');
      var mode = group ? group.getAttribute('data-heart-boxmode-current') : 'none';
      if (mode === 'double' && !s.offer) {
        mode = 'single';
        if (group) group.setAttribute('data-heart-boxmode-current', 'single');
      }
      var mainBox = boxFor(design1, s.size.value);
      var offerBox = boxFor(design2, offerSizeValue(config, s));
      qsa(panel, '[data-heart-boxmode]').forEach(function (btn) {
        var m = btn.getAttribute('data-heart-boxmode');
        var active = m === mode;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        var isCard = btn.hasAttribute('data-heart-boxcard');
        if (m === 'single') {
          if (isCard) { var ps = qs(btn, '[data-heart-boxprice-mode="single"]'); if (ps) ps.textContent = money(mainBox.pricePence); }
          else btn.innerHTML = (config.offer ? 'Box ' + noun(config) + ' 1' : 'Add a gift box') + ' · ' + money(mainBox.pricePence);
        }
        if (m === 'double') {
          btn.hidden = !s.offer;
          btn.disabled = !s.offer;
          if (s.offer) {
            if (isCard) { var pd = qs(btn, '[data-heart-boxprice-mode="double"]'); if (pd) pd.textContent = money(mainBox.pricePence + offerBox.pricePence); }
            else btn.innerHTML = 'Box both ' + noun(config) + 's · ' + money(mainBox.pricePence + offerBox.pricePence);
          }
        }
      });
      if (group) group.classList.toggle('is-checked', mode !== 'none');
      var picker1 = qs(panel, '[data-heart-box-picker="main"]');
      if (picker1) picker1.hidden = mode === 'none';
      var picker2 = qs(panel, '[data-heart-box-picker="offer"]');
      if (picker2) picker2.hidden = mode !== 'double';
      qsa(panel, '[data-heart-boxdesign]').forEach(function (card) {
        var i = parseInt(card.getAttribute('data-heart-boxdesign'), 10) || 0;
        var scope = card.getAttribute('data-heart-boxdesign-scope') || 'main';
        var selIdx = scope === 'offer' ? (s.giftBoxDesign2 || 0) : (s.giftBoxDesign || 0);
        var active = i === selIdx;
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-pressed', active ? 'true' : 'false');
        var d = designs[i];
        if (!d) return;
        var sizeVal = scope === 'offer' ? offerSizeValue(config, s) : s.size.value;
        var v = boxFor(d, sizeVal);
        var fit = qs(card, '[data-heart-boxfit="' + i + '"]');
        if (fit) fit.textContent = config.itemNoun ? v.label : v.label + ' · fits your ' + (/large/i.test(sizeVal || '') ? 'large' : 'small') + ' heart';
        var pr = qs(card, '[data-heart-boxprice="' + i + '"]');
        if (pr) pr.textContent = money(v.pricePence);
      });
      if (mode !== 'none') giftBoxTotal += mainBox.pricePence;
      if (mode === 'double' && s.offer) giftBoxTotal += offerBox.pricePence;
    }
    var offerTotal = (s.offer && config.offer) ? config.offer.pricePence + (s.offerSize ? s.offerSize.extraPence || 0 : 0) : 0;
    var xlMainDelta = (config.pebbles && config.pebbles.xlFrom && s.count >= config.pebbles.xlFrom) ? (config.pebbles.xlPricePence - (s.size.extraPence || 0)) : 0;
    var xlOfferDelta = (s.offer && config.offer && config.offer.pebbles && config.offer.pebbles.xlFrom && s.offerCount >= config.offer.pebbles.xlFrom) ? (config.offer.pebbles.xlPricePence - (s.offerSize ? (s.offerSize.extraPence || 0) : 0)) : 0;
    var total = config.mainPrice + (s.size.extraPence || 0) + offerTotal + extrasTotal + surcharge + giftBoxTotal + xlMainDelta + xlOfferDelta;
    qs(panel, '[data-heart-total]').textContent = money(total);
  }

  function validate(panel, config) {
    var s = state(panel, config);
    if (config.pebbles) {
      for (var p = 0; p < s.count; p++) {
        if (!s.pebbleTypes[p]) return 'Please select the type for pebble ' + (p + 1) + '.';
      }
    }
    for (var i = 0; i < config.fields.length; i++) {
      if (config.fields[i].required && !s.main[i]) return 'Please fill in "' + config.fields[i].label + '".';
    }
    if (s.offer && config.offer) {
      if (config.offer.pebbles) {
        for (var q = 0; q < s.offerCount; q++) {
          if (!s.offerPebbleTypes[q]) return 'Please select the type for pebble ' + (q + 1) + ' on your second ' + noun(config) + '.';
        }
      }
      for (var j = 0; j < config.offer.fields.length; j++) {
        if (config.offer.fields[j].required && !s.offerFields[j]) return 'Please fill in "' + config.offer.fields[j].label + '"' + (/^second\b/i.test(config.offer.fields[j].label || '') ? '.' : ' for your second ' + noun(config) + '.');
      }
    }
    return '';
  }

  function buildItems(config, s) {
    var bundleId = 'heart-' + config.kind + '-' + Date.now();
    var mainProps = { '_Custom option flow': 'Daisy native heart builder', '_Bundle ID': bundleId };
    if (config.pebbles) {
      var atMax = s.count === config.pebbles.max;
      var atLarge = config.pebbles.largeFrom && s.count >= config.pebbles.largeFrom;
      var atXl = !!(config.pebbles.xlFrom && s.count >= config.pebbles.xlFrom);
      var countSuffix = (atXl && config.pebbles.xlCountSuffix) ? config.pebbles.xlCountSuffix : (atLarge && config.pebbles.largeCountSuffix ? config.pebbles.largeCountSuffix : (config.pebbles.countValueSuffix || ''));
      var countValue = (atMax && config.pebbles.maxCountValue) ? config.pebbles.maxCountValue : String(s.count) + countSuffix;
      mainProps[config.pebbles.countKey] = countValue;
      var omitSize = atMax && config.pebbles.omitSizeAtMax;
      if (!omitSize && config.size) mainProps[config.size.key] = s.size.value;
      s.pebbleTypes.forEach(function (t, i) { mainProps[(config.pebbles.pebbleKeyPrefix || 'Pebble ') + (i + 1)] = t; });
    } else if (config.size) {
      mainProps[config.size.key] = s.size.value;
    }
    config.fields.forEach(function (f, i) { mainProps[f.key] = s.main[i]; });
    if (config.staticProps) Object.keys(config.staticProps).forEach(function (k) { mainProps[k] = config.staticProps[k]; });
    (config.extras || []).forEach(function (x, i) { if (x.key) mainProps[x.key] = s.extras[i] ? x.yes : x.no; });
    if (config.offer) mainProps[config.offer.key] = s.offer ? config.offer.yes : config.offer.no;
    if (s.offer && config.offer) {
      if (config.offer.offerSizeKey) mainProps[config.offer.offerSizeKey] = offerSizeValue(config, s);
      if (config.offer.pebbles) {
        var op = config.offer.pebbles;
        var oAtLarge = op.largeFrom && s.offerCount >= op.largeFrom;
        var oAtXl = !!(op.xlFrom && s.offerCount >= op.xlFrom);
        mainProps[op.countKey] = String(s.offerCount) + ((oAtXl && op.xlCountSuffix) ? op.xlCountSuffix : (oAtLarge && op.largeCountSuffix ? op.largeCountSuffix : (op.countValueSuffix || '')));
        s.offerPebbleTypes.forEach(function (t, i) { mainProps[(op.pebbleKeyPrefix || '(Offer) Pebble ') + (i + 1)] = t; });
      }
      config.offer.fields.forEach(function (f, i) { mainProps[f.key] = s.offerFields[i]; });
    }
    var items = [{ id: config.mainVariantId, quantity: 1, properties: mainProps }];
    var xlMain = !!(config.pebbles && config.pebbles.xlFrom && s.count >= config.pebbles.xlFrom);
    if (s.size.helperVariantId && !xlMain) {
      items.push({ id: s.size.helperVariantId, quantity: 1, properties: { '_Linked product': config.title, '_Bundle ID': bundleId, 'Add-on': s.size.helperName || 'Large size' } });
    }
    if (xlMain) {
      items.push({ id: config.pebbles.xlVariantId, quantity: 1, properties: { '_Linked product': config.title, '_Bundle ID': bundleId, 'Add-on': config.pebbles.xlName || '7/8 pebbles' } });
    }
    if (config.pebbles && config.pebbles.countSurcharge && !xlMain && s.count >= config.pebbles.countSurcharge.from) {
      items.push({ id: config.pebbles.countSurcharge.variantId, quantity: 1, properties: { '_Linked product': config.title, '_Bundle ID': bundleId, 'Add-on': config.pebbles.countSurcharge.name } });
    }
    (config.extras || []).forEach(function (x, i) {
      var ex = extraFor(x, s);
      if (s.extras[i]) items.push({ id: ex.variantId, quantity: 1, properties: { '_Linked product': config.title, '_Bundle ID': bundleId, 'Add-on': ex.label } });
    });
    if (s.offer && config.offer) {
      items.push({ id: config.offer.variantId, quantity: 1, properties: { '_Linked product': config.title, '_Bundle ID': bundleId, 'Add-on': config.offer.companionName || 'Second heart' } });
      var xlOffer = !!(config.offer.pebbles && config.offer.pebbles.xlFrom && s.offerCount >= config.offer.pebbles.xlFrom);
      if (s.offerSize && s.offerSize.helperVariantId && !xlOffer) {
        items.push({ id: s.offerSize.helperVariantId, quantity: 1, properties: { '_Linked product': config.title, '_Bundle ID': bundleId, 'Add-on': s.offerSize.helperName || 'Large size (second heart)' } });
      }
      if (xlOffer) {
        items.push({ id: config.offer.pebbles.xlVariantId, quantity: 1, properties: { '_Linked product': config.title, '_Bundle ID': bundleId, 'Add-on': (config.offer.pebbles.xlName || '7/8 pebbles') + ' (second heart)' } });
      }
    }
    if (config.giftBox) {
      var bDesigns = giftBoxDesigns(config);
      var bDesign1 = bDesigns[s.giftBoxDesign] || bDesigns[0];
      var bDesign2 = bDesigns[s.giftBoxDesign2] || bDesigns[0];
      var boxes = [];
      if (s.giftBox) boxes.push({ box: boxFor(bDesign1, s.size.value), design: bDesign1, heart: noun(config, true) + ' 1' });
      if (s.giftBox2 && s.offer) boxes.push({ box: boxFor(bDesign2, offerSizeValue(config, s)), design: bDesign2, heart: noun(config, true) + ' 2' });
      if (boxes.length === 2 && boxes[0].box.variantId === boxes[1].box.variantId) {
        items.push({ id: boxes[0].box.variantId, quantity: 2, properties: { '_Bundle ID': bundleId, '_Linked product': boxes[0].design.productTitle || config.title, 'Gift box design': boxes[0].design.title, 'Gift box size': boxes[0].box.label, 'Gift box for': noun(config, true) + ' 1 & ' + noun(config, true) + ' 2' } });
      } else {
        boxes.forEach(function (b) {
          items.push({ id: b.box.variantId, quantity: 1, properties: { '_Bundle ID': bundleId, '_Linked product': b.design.productTitle || config.title, 'Gift box design': b.design.title, 'Gift box size': b.box.label, 'Gift box for': b.heart } });
        });
      }
    }
    return items;
  }

  function addItem(item) {
    var data = new FormData();
    data.append('id', String(item.id));
    data.append('quantity', String(item.quantity));
    Object.keys(item.properties).forEach(function (key) { if (item.properties[key]) data.append('properties[' + key + ']', item.properties[key]); });
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin', body: data }).then(function (r) {
      if (r.ok) return r.json();
      return r.json().catch(function () { return {}; }).then(function (body) { throw new Error(body.description || 'The selected products could not be added to basket.'); });
    });
  }

  function showError(panel, msg) {
    var el = qs(panel, '[data-heart-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.classList.toggle('is-visible', !!msg);
    if (msg) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function submit(panel, config) {
    if (submitting) return;
    var err = validate(panel, config);
    if (err) { showError(panel, err); return; }
    submitting = true;
    showError(panel, '');
    var btn = qs(panel, '[data-heart-submit]');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var s = state(panel, config);
    var items = buildItems(config, s);
    var sequence = Promise.resolve();
    items.forEach(function (item) { sequence = sequence.then(function () { return addItem(item); }); });
    var timeout = setTimeout(function () { submitting = false; if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; } showError(panel, 'That took too long — please try again.'); }, CART_TIMEOUT_MS);
    sequence.then(function () {
      clearTimeout(timeout);
      window.location.href = (window.routes && window.routes.cart) || '/cart';
    }).catch(function (reason) {
      clearTimeout(timeout);
      submitting = false;
      if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
      showError(panel, reason.message || 'Something went wrong. Please try again.');
    });
  }

  function moveSubmitIntoPanel(form, panel) {
    var slot = qs(panel, '[data-heart-cart-slot]');
    if (!slot) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'product-form__submit button button--secondary';
    button.setAttribute('data-heart-submit', '');
    button.textContent = 'Add to cart';
    slot.appendChild(button);
    removeNativeControls();
  }

  function removeNativeControls() {
    qsa(document, 'button[name="add"], #product-add-to-cart').forEach(function (btn) {
      if (!btn.hasAttribute('data-heart-submit')) btn.remove();
    });
    qsa(document, '.productView-quantity, quantity-input, .productView-qty, [data-quantity-selector], .productView-subtotal').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
    if (!qs(document, '[data-heart-hide-styles]')) {
      var style = document.createElement('style');
      style.setAttribute('data-heart-hide-styles', '');
      style.textContent = '.productView-quantity, quantity-input, .productView-qty, .productView-subtotal { display: none !important; } .productView-buttons .product-form__submit:not([data-heart-submit]) { display: none !important; }';
      document.head.appendChild(style);
    }
  }

  function hideGlobo() {
    qsa(document, '.gpo-container,.gpo-app,.gpo-options,.globo-product-options,.globo-options,[class*="globo-product"],[data-gpo]').forEach(function (node) {
      node.setAttribute('aria-hidden', 'true');
      node.style.setProperty('display', 'none', 'important');
    });
  }

  function getForm() {
    var forms = qsa(document, 'product-form form[data-type="add-to-cart-form"],form[action*="/cart/add"]');
    return forms.filter(function (f) { return !!qs(f, 'input[name="id"]'); })[0] || forms[0] || null;
  }

  function init() {
    var root = qs(document, '[data-daisy-heart-builder]');
    if (!root) return;
    var config = readConfig(root);
    var form = getForm();
    if (!config || !form) return;
    var panel = createPanel(config);
    form.insertBefore(panel, qs(form, '.productView-buttons') || null);
    moveSubmitIntoPanel(form, panel);
    hideGlobo();
    window.setInterval(function () { hideGlobo(); removeNativeControls(); }, 1500);
    panel.addEventListener('input', function () { update(panel, config); });
    panel.addEventListener('change', function () { update(panel, config); });
    panel.addEventListener('click', function (e) {
      var modeBtn = e.target.closest('[data-heart-boxmode]');
      if (modeBtn) {
        var grp = qs(panel, '[data-heart-boxmode-group]');
        var nextMode = modeBtn.getAttribute('data-heart-boxmode');
        if (grp && modeBtn.hasAttribute('data-heart-boxtoggle') && grp.getAttribute('data-heart-boxmode-current') === nextMode) nextMode = 'none';
        if (grp) grp.setAttribute('data-heart-boxmode-current', nextMode);
        update(panel, config);
        return;
      }
      if (!e.target.closest('[data-dm-zoomable]')) {
        var designBtn = e.target.closest('[data-heart-boxdesign]');
        if (designBtn) {
          var designScope = designBtn.getAttribute('data-heart-boxdesign-scope') || 'main';
          qsa(panel, '[data-heart-boxdesign-scope="' + designScope + '"]').forEach(function (b) { b.classList.toggle('is-active', b === designBtn); });
          update(panel, config);
          return;
        }
      }
      var oMinus = e.target.closest('[data-heart-offer-count-minus]');
      var oPlus = e.target.closest('[data-heart-offer-count-plus]');
      if ((oMinus || oPlus) && config.offer && config.offer.pebbles) {
        var oEl = qs(panel, '[data-heart-offer-count]');
        var oCount = parseInt(oEl.textContent, 10) || config.offer.pebbles.defaultCount;
        oCount += oPlus ? 1 : -1;
        oCount = Math.max(config.offer.pebbles.min, Math.min(config.offer.pebbles.max, oCount));
        oEl.textContent = String(oCount);
        update(panel, config);
        return;
      }
      if (!config.pebbles) return;
      var minus = e.target.closest('[data-heart-count-minus]');
      var plus = e.target.closest('[data-heart-count-plus]');
      if (!minus && !plus) return;
      var el = qs(panel, '[data-heart-count]');
      var count = parseInt(el.textContent, 10) || config.pebbles.defaultCount;
      count += plus ? 1 : -1;
      count = Math.max(config.pebbles.min, Math.min(config.pebbles.max, count));
      el.textContent = String(count);
      update(panel, config);
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-heart-submit]')) { e.preventDefault(); submit(panel, config); }
    }, true);
    form.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); submit(panel, config); }, true);
    update(panel, config);
    root.hidden = false;
    if (config.hideCountdown) {
      var killCountdown = function () { qsa(document, '.price-countdown-widget').forEach(function (n) { n.remove(); }); };
      killCountdown();
      window.setInterval(killCountdown, 1500);
    }
    document.addEventListener('click', function (e) {
      var pre = e.target.closest && e.target.closest('[data-dm-preset]');
      if (!pre) return;
      e.preventDefault();
      var want = pre.getAttribute('data-dm-preset');
      var offerEl = qs(panel, 'input[name="daisy-heart-offer"]');
      var grp = qs(panel, '[data-heart-boxmode-group]');
      if (want === 'two' && offerEl) offerEl.checked = true;
      if (grp && (want === 'box' || want === 'two')) grp.setAttribute('data-heart-boxmode-current', want === 'two' ? 'double' : 'single');
      update(panel, config);
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
